import { GetStaticPaths, GetStaticProps } from 'next'

import query from './queries'

import initApollo, { API } from 'src/api'

export type Props = API.HallOfFameHome

export const getStaticProps: GetStaticProps<Props> = async () => {
  const client = initApollo({})

  const { data } = await client.query<API.HallOfFameHome>({
    query,
  })

  return {
    props: data,
  }
}
